import request from './httpService';

const HELP_API_ENDPOINT = '/help';

const HelpService = {
  /**
   * Get all help articles grouped by category
   */
  getAllArticles: (signal) => {
    return request({
      method: 'GET',
      url: `${HELP_API_ENDPOINT}/articles`,
      signal,
    });
  },

  /**
   * Get a single help article with markdown content
   */
  getArticleBySlug: (slug, signal) => {
    return request({
      method: 'GET',
      url: `${HELP_API_ENDPOINT}/articles/${slug}`,
      signal,
    });
  },

  /**
   * Search help articles by query
   */
  searchArticles: (query, signal) => {
    return request({
      method: 'GET',
      url: `${HELP_API_ENDPOINT}/search`,
      params: { q: query },
      signal,
    });
  },
};

export default HelpService;
